export default __webpack_public_path__ + "static/zencart-logo-78e3108c296bec2b7d5208e1a22e3138.png";